import { render, staticRenderFns } from "./CompensationYear.vue?vue&type=template&id=ba1db0ea&scoped=true"
import script from "./CompensationYear.vue?vue&type=script&lang=js"
export * from "./CompensationYear.vue?vue&type=script&lang=js"
import style0 from "./CompensationYear.vue?vue&type=style&index=0&id=ba1db0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1db0ea",
  null
  
)

export default component.exports